import type { StickyShareButtonsConfig } from 'sharethis-reactjs';
import { StickyShareButtons } from 'sharethis-reactjs';
import { TrackingAction, TrackingCategory, trackingService } from '../../services';

export interface ShareButtonsProps {
  /** The language to use for the buttons. */
  language: string;
  /** The url to share. */
  url: string;
}

export type CustomStickyShareButtonsConfig = Omit<StickyShareButtonsConfig, 'top'> & {
  top: any;
};

const ShareButtons = ({ language, url }: ShareButtonsProps) => {
  const sbConfig: CustomStickyShareButtonsConfig = {
    alignment: 'left',
    color: 'social',
    enabled: true,
    font_size: 14,
    labels: 'cta',
    language,
    url,
    min_count: 0,
    padding: 12,
    show_mobile: false,
    show_total: false,
    show_toggle: true,
    radius: 4,
    size: 48,
    top: 'calc(50% - 110px)',
    networks: ['twitter', 'facebook', 'whatsapp', 'wechat'],
  };

  const sendClickedEvent = () => {
    trackingService.event(TrackingCategory.Social, TrackingAction.CLICKED_STICKY_SHARE);
  };

  return (
    <div onClick={sendClickedEvent}>
      <StickyShareButtons config={sbConfig} />
    </div>
  );
};

export default ShareButtons;
